import { useState, useEffect } from "react";
import { io } from "socket.io-client";
import { getTimeoutConfig } from "../config/timeoutConfig";
import logger from "../utils/logger";


export function useWebSocket(
  matchId,
  setCodes = () => {},
  setScoreA = () => {},
  setScoreB = () => {},
  setSetsA = () => {},
  setSetsB = () => {},
  setCurrentSet = () => {},
  setMatchOver = () => {},
  setShowEndSetDialog = () => {},
  setScoutingCodes = () => {},
  setSetDuration = () => {},
  setShowSetDurationDialog = () => {},
  handleRotationUpdate = () => {},
  setSetWinner = () => {},
) { 
  const [socket, setSocket] = useState(null);
  const [timeouts, setTimeouts] = useState({ teamA: 0, teamB: 0 });
  const [isTimeoutActive, setIsTimeoutActive] = useState(false);
  const [timeoutDuration, setTimeoutDuration] = useState(0);
  const [timeoutType, setTimeoutType] = useState(null); 
  //const [sets, setSets] = useState({}); 
  //const [setsWon, setSetsWon] = useState({ teamA: 0, teamB: 0 }); // ✅ Ensures `setsWon` is always defined
  //const [playerMap, setPlayerMap] = useState({ teamA: {}, teamB: {} });
  //const [latestRotationUpdate, setLatestRotationUpdate] = useState(null);
  const [matchState, setMatchState] = useState(null); // ✅ Store match state globally
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    const newSocket = io(API_BASE_URL, {
      perMessageDeflate: true,
      withCredentials: true
    });
    setSocket(newSocket);

    newSocket.on("connect", () => {
      logger.debug("🛜 [DEBUG] Socket Connected:", newSocket.id);
    });

    newSocket.on("connect_error", (err) => {
      console.error("🛜 [ERROR] Socket Connection Error:", err.message);
    });

    newSocket.on("error", (err) => {
      console.error("🛜 [ERROR] Socket Generic Error:", err);
    });

    newSocket.on("disconnect", (reason) => {
      console.warn("🛜 [WARN] Socket Disconnected:", reason);
    });

    console.log("📡 Joining match with ID:", matchId);
    newSocket.emit("joinMatch", matchId);

    // ✅ Handle score updates and calling timeout
newSocket.on("matchStateUpdate", (data) => {
  logger.debug("🛜 [DEBUG] Full matchState update received:", data);

  // Safely merge new matchState data into our existing matchState
  setMatchState((prevState) => ({
    ...prevState,
    ...data,
    sets: {
      ...(prevState?.sets ?? {}),
      ...(data.sets ?? {}),
    },
    teams: data.teams ?? prevState?.teams ?? {},
    setsWon: data.setsWon ?? prevState?.setsWon ?? { teamA: 0, teamB: 0 },
  }));

  // Update local scoreboard
  setScoreA(data.sets?.[data.currentSet]?.scoreA ?? 0);
  setScoreB(data.sets?.[data.currentSet]?.scoreB ?? 0);
  setCurrentSet(data.currentSet);

  // IMPORTANT: Now we also set matchOver state if server says so
  if (typeof data.matchOver !== "undefined") {
    setMatchOver(Boolean(data.matchOver));
  }
});


/*
newSocket.on("scoreUpdate", (data) => {
    if (data.matchId === matchId) {
        const currentSetData = data.sets?.[data.currentSet] || {}; // ✅ Extract the active set
		console.log("🛜 [DEBUG] scoreupdate:", data);
		if (typeof currentSetData?.scoreA === "undefined" || typeof currentSetData?.scoreB === "undefined") {
            console.warn("⚠️ Skipping score update because scoreA or scoreB is undefined.");
            return;
        }
		setMatchState(data);
        setScoreA(currentSetData.scoreA ?? 0);
        setScoreB(currentSetData.scoreB ?? 0);
        setCurrentSet(data.currentSet);

        console.log(`📊 Score Updated - Team A: ${currentSetData.scoreA}, Team B: ${currentSetData.scoreB}, Set: ${data.currentSet}`);

        const shouldTrigger = getTimeoutConfig(matchState?.rules).TECHNICAL.canTrigger(
          data.currentSet,
          currentSetData.scoreA,
          currentSetData.scoreB
        );
        console.log(`🔍 Checking Technical Timeout: Set=${data.currentSet}, Score A=${currentSetData.scoreA}, Score B=${currentSetData.scoreB}, Should Trigger=${shouldTrigger}`);

        if (shouldTrigger) {
            console.log(`⏳ Technical Timeout triggered for match ${matchId}`);
            newSocket.emit("requestTimeout", { matchId, type: getTimeoutConfig(matchState?.rules).TECHNICAL.type });
        }
    }
});
*/

newSocket.on("timeoutStarted", (data) => {
    console.log(`⏳ Timeout started (${data.type}) for ${data.duration}s`);

    if (!data.duration) {
        console.error("❌ Timeout started but duration is undefined:", data);
        return;
    }

    setIsTimeoutActive(true);
    setTimeoutDuration(data.duration);
    setTimeoutType(data.type); // ✅ Store timeout type (TEAM or TECHNICAL)
    console.log(`🔍 timeoutStarted Timeout Type Set: ${data.type}`);

});

newSocket.on("timeoutUpdate", (data) => {
    if (data.matchId === matchId) {
        console.log("⏳ Timeout count updated:", data.timeout); // ✅ Now correctly referencing "timeout"
        setTimeouts({ ...data.timeout }); // ✅ Now using "timeout"
    }
});

newSocket.on("timeoutUpdated", (data) => {
    if (data.matchId === matchId) {
        console.log(`⏳ Timeout updated: ${data.remainingTime}s remaining`);
        setTimeoutDuration(data.remainingTime); // ✅ Sync countdown from WebSocket
    }
});

newSocket.on("timeoutEnded", () => {
    console.log("⏳ Timeout ended. Resuming match.");
    setIsTimeoutActive(false);
    setTimeoutDuration(0);
    setTimeoutType(null); // ✅ Clear timeout type
});



    // ✅ Handle scouting updates
    newSocket.on("scoutingUpdate", (data) => {
      logger.trace("🛜 [TRACE] Scouting Update Received:", data);
      
      if (!data) return;

      // Safeguard: don't overwrite with undefined
      if (data.scoutingCodes && Array.isArray(data.scoutingCodes)) {
        logger.trace("🔄 [TRACE] Bulk updating scoutingCodes from server. Count:", data.scoutingCodes.length);
        setScoutingCodes(data.scoutingCodes);
      }

      if (data.scoutingEntry) {
        setScoutingCodes(prev => {
          if (!Array.isArray(prev)) {
            logger.trace("❌ [TRACE] prev scoutingCodes is NOT an array (in scoutingUpdate listener):", prev);
            return [data.scoutingEntry];
          }
          
          const exists = prev.some(entry => entry.uuid === data.scoutingEntry.uuid);
          if (exists) {
            logger.trace("ℹ️ [TRACE] Updating confirmed entry. UUID:", data.scoutingEntry.uuid);
            return prev.map(entry => entry.uuid === data.scoutingEntry.uuid 
                ? {...entry, ...data.scoutingEntry, status: "confirmed"} 
                : entry
            );
          }
          logger.trace("🆕 [TRACE] Appending confirmed entry from server. UUID:", data.scoutingEntry.uuid);
          return [...prev, {...data.scoutingEntry, status: "confirmed"}];
        });
      }
    });

    // ✅ Handle end set confirmation
    newSocket.on("confirmSetEnd", (data) => {
      console.log("🛜 WebSocket confirmSetEnd received");
	  setSetWinner(data.winner); // 👈 capture "teamA" or "teamB" emitted by checkSetWin for use later by processSetEnd
      setShowEndSetDialog(true);
    });
	
// ✅ Handle rotation updates
newSocket.on("rotationUpdate", (data) => {
    console.log("🛜 WebSocket rotationUpdate event received:", data);

    if (!data || !data.currentSet || !data.rotations) {
        console.error("❌ [rotationUpdate] Missing required match data:", data);
        return;
    }

    handleRotationUpdate({
        matchId: data.matchId,
        currentSet: data.currentSet, // ✅ Now tracks which set the rotation belongs to
        rotations: data.rotations, // ✅ Now includes both teamA and teamB rotations
		playerMap: data.playerMap
    });
});

newSocket.on("showSetSummary", (data) => {
  console.log("📊 showSetSummary received — now showing SetDurationDialog");
  setShowSetDurationDialog(true); // ✅ Only show now
});

        // ✅ Listen for match timer pause due to timeout
        newSocket.on("timerPause", () => {
            setIsTimeoutActive(true);
            setTimeoutDuration(30);
        });

        // ✅ Listen for match timer resume after timeout ends
        newSocket.on("resumeTimer", () => {
            setIsTimeoutActive(false);
            setTimeoutDuration(0);
        });

return () => {
    newSocket.disconnect();
    newSocket.off("scoreUpdate");
    newSocket.off("setUpdate");
    newSocket.off("rotationUpdate"); 
    newSocket.off("showSetSummary");
    newSocket.off("timeoutUpdate");
    newSocket.off("timeoutStarted");
    newSocket.off("timeoutUpdated");
    newSocket.off("timeoutEnded");
};

  }, [matchId]);




    // ✅ Function to request a timeout (used for both technical and team timeouts)
const requestTimeout = (type, team) => {
    if (!socket) return;
    console.log(`⏳ Requesting ${type} timeout for match ${matchId}, Team: ${team}`);
    socket.emit("requestTimeout", { matchId, type, team });
};

// ✅ Function to call a team timeout (passes `team` to requestTimeout)
const requestTeamTimeout = (team) => {
    const cfg = getTimeoutConfig(matchState?.rules);
    requestTimeout(cfg.TEAM.type, team);
};
	
  return {
        socket,
		matchState,
		setMatchState,
		//playerMap,
        timeouts,
        isTimeoutActive,
        timeoutDuration,
        requestTimeout,
		timeoutType,
		requestTeamTimeout 
    };
}
